import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
@Component({
  selector: 'app-observaciones-dte',
  templateUrl: './observaciones-dte.component.html',
  styleUrls: ['./observaciones-dte.component.scss']
})
export class ObservacionesDteComponent implements OnInit, OnChanges {
  public ObservacionesGroupForm: FormGroup;

  @Input() initialObservaciones: string = "";
  @Output() observacionesChange = new EventEmitter<string>();

  constructor(private builder: FormBuilder) { }

  ngOnInit(): void {
    this.ObservacionesGroupForm = this.builder.group({
      observaciones: ['', [Validators.maxLength(500)]]
    });
    this.patchInitialObservaciones();
    this.ObservacionesGroupForm.get('observaciones').valueChanges
      .subscribe(value => {
        this.observacionesChange.emit(value);
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["initialObservaciones"]) {
      this.patchInitialObservaciones();
    }
  }

  private patchInitialObservaciones(): void {
    if (!this.ObservacionesGroupForm || this.initialObservaciones == null) return;
    this.ObservacionesGroupForm.controls.observaciones.patchValue(this.initialObservaciones, { emitEvent: false });
    this.observacionesChange.emit(this.initialObservaciones);
  }
}
